import Labels from '../enums/Labels';

interface ProgressBarStep {
  step: number;
  name: Labels;
  active: boolean;
  valid: boolean;
  done: boolean;
  path: string;
}

export default ProgressBarStep;

export const ProgressBarDefaults = [
  {
    step: 1,
    name: Labels.PROGRESS_BAR_STEP1,
    path: 'instructions',
    active: true,
    valid: false,
    done: false,
  },
  {
    step: 2,
    name: Labels.PROGRESS_BAR_STEP2,
    path: 'personal-details',
    active: false,
    valid: false,
    done: false,
  },
  /* {
    step: 3,
    name: 'risk',
    path: 'questionnaire',
    active: false,
    valid: false,
    done: false,
  }, */
  {
    step: 3,
    name: Labels.PROGRESS_BAR_STEP3,
    path: 'questionnaire',
    active: false,
    valid: false,
    done: false,
  },
  {
    step: 4,
    name: Labels.PROGRESS_BAR_STEP4,
    path: 'documents',
    active: false,
    valid: false,
    done: false,
  },
  {
    step: 5,
    name: Labels.PROGRESS_BAR_STEP5,
    path: 'conclusion',
    active: false,
    valid: false,
    done: false,
  },
];
